export default "/images/close_btn.png?ca6e68f2fa95b53272d6e5d11502cc13";